import CategoriaService from "@/api/services/finanzas/nomencladores/CategoriaService"
import Vue from "vue"

const state = () => ({
    categorias: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    CATEGORIAS: state => {
        return state.categorias
    },
    CATEGORIAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_CATEGORIAS: (state, payload) => {
        state.categorias = payload
    },

    SET_CATEGORIAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_CATEGORIA: (state, payload) => {
        state.categorias.push(payload)
    },

    UPDATE_CATEGORIA: (state, payload) => {
        state.categorias = state.categorias.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_CATEGORIA: (state, payload) => {
        state.categorias = state.categorias.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_CATEGORIAS: async ({ commit, state }, { filter, categoriaEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await CategoriaService.get({ filter, categoriaEstado, ...pagination })
            if (status === 200) {
                commit("SET_CATEGORIAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las categorías del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_CATEGORIAS: async ({ commit }) => {
        try {
            let { data, status } = await CategoriaService.getAll()
            if (status === 200) {
                commit("SET_CATEGORIAS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_CATEGORIAS: async ({ commit }) => {
        try {
            let { data, status } = await CategoriaService.getAllRecords()
            if (status === 200) {
                commit("SET_CATEGORIAS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las categorías el activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ACTIVO_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await CategoriaService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_CATEGORIA", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial para la categoría del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await CategoriaService.post(payload)
            if (status === 201) {
                commit("ADD_CATEGORIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La categoría ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la categoría, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { data, status } = await CategoriaService.put(payload)
            if (status === 200) {
                commit("UPDATE_CATEGORIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La categoría ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la categoría, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_CATEGORIA: async ({ commit }, payload) => {
        try {
            let { status, data } = await CategoriaService.delete(payload)
            if (status === 204) {
                commit("DELETE_CATEGORIA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La categoría ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_CATEGORIA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La categoría ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la categoría del activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
